import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import DiaryTop from './DiaryTop';
import DiaryEdit from './DiaryEdit';
import DiaryReport from './DiaryReport';

// 画面遷移作成
const MainStack = createNativeStackNavigator();

/** ================================
*  作業日誌画面ナビゲーション
*  ================================*/
export default function DiaryNavigator() {
  return (
    <MainStack.Navigator screenOptions={{ headerShown: false }}>
      <MainStack.Screen name="DiaryTop" component={DiaryTop} options={{ title: '作業日誌' }} />
      <MainStack.Screen name="DiaryEdit" component={DiaryEdit} options={{ title: '作業日誌編集' }} />
      <MainStack.Screen name="DiaryReport" component={DiaryReport} options={{ title: '作業日誌レポート' }} />
    </MainStack.Navigator>
  );
}
